
import React from "react";
import { Progress } from "@/components/ui/progress";
import { useExperience } from "@/hooks/use-experience";

export const XpProgressBar: React.FC = () => {
  const { experience, isLoading } = useExperience();

  if (isLoading) {
    return (
      <div className="w-full flex items-center gap-2" aria-busy="true" aria-label="Loading experience">
        <div className="text-[10px] md:text-xs opacity-70 select-none">XP</div>
        <div className="w-full">
          <Progress value={30} className="h-2 md:h-3 bg-secondary/50" />
        </div>
      </div>
    );
  }

  if (!experience) {
    return null;
  }

  const { currentLevel, currentRank, totalXp, nextLevelXp, progressPercentage } = experience;
  
  // Calculate XP remaining and current level XP for display
  const xpRemaining = nextLevelXp - totalXp;
  const currentLevelStartXp = currentLevel > 1 ? [0, 100, 300, 600, 1000, 1500, 2100, 2800, 3600, 4500, 5500, 6600, 7800, 9100, 10500, 12000, 13600, 15300, 17100, 19000][currentLevel - 1] : 0;

  return (
    <div className="w-full flex items-center gap-2" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progressPercentage)} aria-label={`Level ${currentLevel} ${currentRank} progress`} title={`Level ${currentLevel} • ${currentRank} — ${Math.round(progressPercentage)}% to next level (${totalXp}/${nextLevelXp} XP)`}>
      <div className="hidden sm:block text-[10px] md:text-xs opacity-80 whitespace-nowrap select-none">
        Lv {currentLevel}
      </div>
      <div className="w-full">
        <Progress value={progressPercentage} className="h-2 md:h-3 bg-win95-lightgray" />
      </div>
      {/* XP remaining info - responsive display */}
      <div className="hidden md:block text-[10px] md:text-xs opacity-80 whitespace-nowrap select-none">
        {xpRemaining} XP
      </div>
      <div className="hidden lg:block text-[10px] md:text-xs opacity-80 whitespace-nowrap select-none">
        {Math.round(progressPercentage)}%
      </div>
    </div>
  );
};

export default XpProgressBar;
